import { Anchor, Text } from "@mantine/core";
import { Link } from "react-router";
import { AuthCard } from "./AuthCard";

export function NotFoundPage() {
  return (
    <AuthCard title="Page not found">
      <Text size="sm">
        <Anchor component={Link} to="/">Go to Home</Anchor>
      </Text>
    </AuthCard>
  );
}
